<script lang="ts" setup>
import ServiceHighlight from "~/components/article/ServiceHighlight.vue";
import type {PageCollectionItemBase} from "@nuxt/content";

const {collectionUri} = useI18nCollection();
const {getIndex, getAllButIndex} = usePage();
const pages: PageCollectionItemBase[] = await queryCollection(collectionUri('services')).all();
const index = getIndex(pages)!;
const entries = getAllButIndex(pages)!.sort((a, b) => (a.meta?.order || 0) - (b.meta?.order || 0));
</script>

<template>
  <section id="soins" class="container scroll-mt-10 tablet:scroll-mt-30">
    <header class="mb-12 max-w-2xl mx-auto text-center">
      <h2 class="section-title text-brand mb-2">{{ index.title }}</h2>
      <ContentRenderer :value="index" class="text-brand/66 with-free-text"/>
    </header>

    <div>
      <ServiceHighlight
              v-for="(service, serviceIndex) in entries"
              :key="service.path"
              :title="service.title"
              :price="service.meta?.price as string"
              :duration="service.meta?.duration as string"
              :odd="serviceIndex % 2 === 0"
              :booking-url="service?.meta?.booking_url as string || ''"
              :img-uri="(service.meta?.image as string || '').replace('/assets', '')"
              :class="{ 'flex-row-reverse': serviceIndex % 2 === 0, 'flex-row': serviceIndex % 2 !== 0 }"
      >
        <template #summary>
          <ContentRenderer :value="service" class="tablet:text-sm laptop:text-base"/>
        </template>
      </ServiceHighlight>
    </div>

    <footer v-if="index?.meta?.cta" class="text-center">
      <ButtonCta v-for="cta in index.meta.cta" :key="cta.label" :cta="cta" class="btn-lg"/>
    </footer>
  </section>
</template>